import { useEffect } from 'react';
import { VkLogin } from '../components/VkLogin';

const Cube = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7l10 5 10-5-10-5Z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

export function LoginPage() {
  useEffect(() => {
    // Уже авторизован → на дашборд
    fetch('/api/user/me', { credentials: 'include' })
      .then((res) => {
        if (res.ok) window.location.href = '/dashboard';
      })
      .catch(() => {});
  }, []);

  return (
    <div className="auth-bg">
      <div className="auth-card">
        <div className="auth-head">
          <div className="auth-logo">
            <Cube />
          </div>
          <h1 className="auth-title">TARS</h1>
          <p className="auth-sub">Вход через VK ID</p>
        </div>
        <VkLogin onSuccess={() => (window.location.href = '/dashboard')} />
      </div>
    </div>
  );
}
